import { Delete } from '@mui/icons-material';
import EditIcon from '@mui/icons-material/Edit';
import { Box, Button, IconButton, Tooltip } from "@mui/material";
import { MaterialReactTable, useMaterialReactTable } from "material-react-table";
import { useMemo, useState } from "react";
import { tableConfig } from "../../../../../../commons/table/tableConfig";
import { StyledResolucion } from "../../../../../../styled/Prevencion";


const ProveedoresTable = ({ data, handleOpenForm, handleDelete, esComprador }) => {
    const [rowSelection, setRowSelection] = useState({});

    const columns = useMemo(() => [
        {
            accessorKey: "razonSocial",
            header: "Razón Social",
            size: 180,
        },
        {
            accessorKey: "cuit",
            header: "CUIT",
            size: 150,
        },
    ], [esComprador]);

    const table = useMaterialReactTable({
        ...tableConfig,
        columns,
        data: data || [],
        enableRowSelection: true,
        state: {
            rowSelection,
        },
        onRowSelectionChange: setRowSelection,
        enableRowActions: true,
        positionActionsColumn: "last",
        displayColumnDefOptions: {
            'mrt-row-actions': {
                header: 'Operaciones',
            },
        },
        renderRowActions: ({ row }) => (
            <Button
                onClick={() => handleOpenForm({ ...row.original, index: row.index })}
                startIcon={<EditIcon />}
                size="small"
                color="primary"
                title="Editar proveedor"
            >
                Editar
            </Button>
        ),
        renderTopToolbarCustomActions: () => (
            <StyledResolucion.HeaderContainer>
                <StyledResolucion.TableTitle>
                    {esComprador ? "Compradores" : "Proveedores"}
                </StyledResolucion.TableTitle>
            </StyledResolucion.HeaderContainer>
        ),
        renderToolbarAlertBannerContent: ({ groupedAlert, selectedAlert, table }) => (
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginLeft: 1,
                }}>
                {selectedAlert}
                <Tooltip title="Eliminar seleccionados">
                    <IconButton
                        onClick={() => {
                            const selectedRows = table.getSelectedRowModel().rows.map(row => row.index);
                            handleDelete(selectedRows);
                            table.resetRowSelection();
                        }}
                    >
                        <Delete />
                    </IconButton>
                </Tooltip>
            </Box>
        ),
        renderBottomToolbarCustomActions: () => (
            <StyledResolucion.TableFooterButtonContainer>
                <Button
                    color="primary"
                    onClick={() => handleOpenForm(null)}
                >
                    Agregar
                </Button>
            </StyledResolucion.TableFooterButtonContainer>
        ),

    });

    return (
        <>
            <StyledResolucion.TableContainer>
                <MaterialReactTable table={table} />
            </StyledResolucion.TableContainer>
        </>
    );
}

export default ProveedoresTable;